import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import searchFetcher from "@/common/fetchSearchServices";
export var api__getSimilarPosts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(postId) {
    var _res$data;
    var size,
      req,
      params,
      res,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          size = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
          req = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
          params = {
            post_id: postId,
            size: size !== null ? size : undefined // If size is provided, include it in the params
          };
          _context.next = 5;
          return searchFetcher(req).get("/similar-items/si_1?", {
            params: params
          });
        case 5:
          res = _context.sent;
          return _context.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__getSimilarPosts(_x) {
    return _ref.apply(this, arguments);
  };
}();